import {
  Typography,
  Container,
  Stack,
  createTheme,
  Box,
  IconButton,
} from "@mui/material";
import logo from "../asset/TIE_LOGO.png";
import camera from "../asset/Group 1000001729.svg";
import fb from "../asset/Group 1000001728 (1).svg";

import useMediaQuery from "@mui/material/useMediaQuery";
import { Grid } from "@material-ui/core";
import "../index.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import brochure from "../asset/Taksheela Brochure.pdf";

import { Link, useNavigate } from "react-router-dom";
import DangerousIcon from "@mui/icons-material/Dangerous";
import { useState } from "react";
import EastIcon from "@mui/icons-material/East";
import { Icon } from "@iconify/react";
import { WEB_URL } from "src/config";

const Footer = () => {
  const navigate = useNavigate();
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const largeScreen = createTheme({
    breakpoints: {
      values: {
        xxl: 1920,
      },
    },
  });
  const [toggleOpen, setToggleOpen] = useState(true);
  const isLargeScreen = useMediaQuery(largeScreen.breakpoints.up("xxl"));

  const openWhatsAppInNewTab = () => {
    const phoneNumber = "+919831241212";
    const whatsappLink = `https://wa.me/${phoneNumber}`;
    window.open(whatsappLink, "_blank");
  };
  const handlePhoneIconClick = () => {
    // window.open(`tel:${+917980876611}`);
    window.open(`tel:${+919831241212}`);
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = brochure;
    link.setAttribute("download", "Taksheela Brochure.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Container maxWidth={isLargeScreen ? "xl" : "lg"}>
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: "0.5rem", md: 1, lg: 1, sm: 1 },
            fontSize: "17px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            textTransform: "capitalize",
          }}
        >
          {/* Logo Section */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={3}
            sx={{
              flex: 1,
              mb: { xs: 2, sm: 0 },
            }}
          >
            <a href={`${WEB_URL}`} target="_self" rel="noopener noreferrer">
              <img
                src={logo}
                width="150px"
                style={{ marginTop: "-36px" }}
                alt="Taksheela Logo"
              />
            </a>

            <Stack
              sx={{
                flex: 1,
                margin: "-10px 0px 0px 12px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="body2"
                color="#606060"
                sx={{ display: "grid", gap: 1 }}
              >
                <Typography sx={{ fontSize: { xs: 14, md: 16, lg: 17 } }}>
                  <Typography variant="span" sx={{ fontWeight: "600" }}>
                    Dubai office:{" "}
                  </Typography>
                  Sharjah Media City, Sharjah - United Arab Emirates
                </Typography>

                <Typography sx={{ fontSize: { xs: 14, md: 16, lg: 17 } }}>
                  <Typography variant="span" sx={{ fontWeight: "600" }}>
                    Delhi office:{" "}
                  </Typography>
                  Hub Hive 11, 1st Floopr, 262, Plot 1, ITDC Western Marg, Near
                  Saket Metro, New Delhi 110017
                </Typography>

                <Typography sx={{ fontSize: { xs: 14, md: 16, lg: 17 } }}>
                  <Typography variant="span" sx={{ fontWeight: "600" }}>
                    Mumbai office:{" "}
                  </Typography>
                  613 , OPAL Square , Wagle Estate , Thane 40060
                </Typography>

                <Typography sx={{ fontSize: { xs: 14, md: 16, lg: 17 } }}>
                  <Typography variant="span" sx={{ fontWeight: "600" }}>
                    Banglore office:{" "}
                  </Typography>
                  C8, Kudremukh Colony , Koramangala 2nd Block, Sarjapura road.
                  Near water tank, Bangalore: 560034
                </Typography>

                <Typography sx={{ fontSize: { xs: 14, md: 16, lg: 17 } }}>
                  <Typography variant="span" sx={{ fontWeight: "600" }}>
                    Kolkata Office :{" "}
                  </Typography>
                  79/16 Palm Avenue, Ballygunje Phari, Kolkata – 700019.
                </Typography>

                <Typography sx={{ fontSize: { xs: 14, md: 16, lg: 17 } }}>
                  <Typography variant="span" sx={{ fontWeight: "600" }}>
                    Email:{" "}
                  </Typography>
                  <a href="mailto:info@taksheela.com">info@taksheela.com</a>
                </Typography>
              </Typography>

              <Stack
                sx={{
                  display: "flex",
                  gap: ".5rem",
                  flexDirection: "row",
                  marginTop: "10px",
                  fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                  paddingBottom: {
                    xs: "12px",
                    sm: "12px",
                    md: "0px",
                    lg: "0px",
                  },
                }}
              >
                <Box sx={{ display: "flex" }}>
                  <a
                    href="https://www.instagram.com/taksheela_studyabroad/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ margin: "5px" }}
                  >
                    <img
                      src={camera}
                      style={{ width: isSmScreen ? "35px" : "35px" }}
                      alt="Camera"
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/taksheelainstituteofeducation/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ margin: "5px" }}
                  >
                    <img
                      src={fb}
                      style={{ width: isSmScreen ? "35px" : "35px" }}
                      alt="Facebook"
                    />
                  </a>
                </Box>
              </Stack>

              <WhatsAppIcon
                message="Hello, how can we help you?"
                phoneNumber="6267293696"
                position="right"
                showPopup={false}
                onClick={openWhatsAppInNewTab}
                sx={{
                  position: "fixed",
                  bottom: "20px",
                  right: "20px",
                  fontSize: "40px",
                  padding: "5px",
                  backgroundColor: "#25d366",
                  color: "#fff !important",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  zIndex: 20,
                }}
              />

              <CallIcon
                message="Hello, how can we help you?"
                phoneNumber="6267293696"
                position="right"
                showPopup={false}
                onClick={handlePhoneIconClick}
                style={{
                  position: "fixed",
                  bottom: "20px",
                  fontSize: "40px",
                  padding: "5px",
                  right: "70px",
                  color: "#F0F0F0",
                  backgroundColor: "#1976d2",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  zIndex: 20,
                }}
              />

              <Box
                message="Hello, how can we help you?"
                position="left"
                showPopup={false}
                sx={{
                  position: "fixed",
                  bottom: "70px",
                  right: "20px",
                  height: "auto",
                  width: "300px",
                  color: "#fff !important",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  zIndex: 20,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  flexDirection: "row",
                }}
                gap={1}
              >
                {toggleOpen &&
                  window.location.pathname !==
                    "/study-abroad/universityFinder" && (
                    <Box
                      sx={{
                        zIndex: 100,
                        color: "white",
                        background: "linear-gradient(135deg, #00999E, #00777E)", // Gradient background
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "25px 25px",
                        fontWeight: "bold",
                        fontSize: "16px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", // Enhanced shadow for depth
                        cursor: "pointer",
                        // animation: "pulse 2s infinite", // Pulse animation
                        // transition: "all 0.3s ease", // Smooth transition for hover effects
                        "&:hover": {
                          transform: "scale(1.05)", // Slight scale-up on hover
                          boxShadow: "0 6px 15px rgba(0, 0, 0, 0.3)", // Enhanced shadow on hover
                        },

                        transition: "all 0.3s ease",
                        overflow: "hidden",
                        animation: "pulse 2s infinite", // Add pulse animation
                        "@keyframes pulse": {
                          "0%": { transform: "scale(1)" },
                          "50%": { transform: "scale(1.1)" }, // Slightly scale up
                          "100%": { transform: "scale(1)" },
                        },
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",

                          borderRadius: "25px 0px 0px 25px",
                          border: "2px solid transparent",
                        },
                      }}
                    >
                      <DangerousIcon
                        onClick={() => {
                          setToggleOpen(false);
                        }}
                        sx={{
                          ml: 1,
                          transition: "transform 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.3)",
                          },
                          zIndex: 100,
                        }}
                      />
                      <Typography
                        sx={{
                          color: "white",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          // padding: "7px 12px",
                          padding: "5px",
                          borderRadius: "25px 0px 0px 25px",
                          fontWeight: "bold",
                          fontSize: "16px",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          zIndex: 100,
                          width: "100%",
                        }}
                        onClick={() => {
                          navigate("/study-abroad/universityFinder");
                        }}
                      >
                        Find Your University
                      </Typography>
                      <EastIcon
                        onClick={() => {
                          navigate("/study-abroad/universityFinder");
                        }}
                        sx={{
                          mr: 0.5,
                          transition: "transform 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.3)",
                          },
                          zIndex: 100,
                        }}
                      />
                    </Box>
                  )}
                {/* <img
                  onClick={() => {
                    navigate("/study-abroad/universityFinder");
                    setToggleOpen(false);
                  }}
                  src={finder}
                  alt=""
                  width={"13%"}
                  height={"13%"}
                  style={{
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.1)", // Slight scale-up on hover
                    },
                  }}
                /> */}
                <IconButton
                  onClick={() => {
                    navigate("/study-abroad/universityFinder");
                    setToggleOpen(false);
                  }}
                  sx={{
                    p: 1,
                    cursor: "pointer",
                    backgroundColor: "#00999E",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      cursor: "pointer",
                      backgroundColor: "#00999E",
                      transform: "scale(1.1)", // Slight scale-up on hover
                    },
                  }}
                >
                  <Icon
                    icon="fa-solid:university"
                    color="#f1f1f1"
                    width="32"
                    height="32"
                  />
                </IconButton>
              </Box>
            </Stack>
          </Grid>

          {/* Services Section */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            lg={3}
            xl={3}
            sx={{
              mb: { xs: 2, sm: 0 },
              display: "grid",
              color: "#606060",
              gap: ".3rem",
            }}
          >
            <Stack sx={{ paddingLeft: { lg: "70px", md: "50px" } }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 14, md: 20, lg: 21 },
                  paddingBottom: "15px",
                }}
              >
                SERVICES
              </Typography>
              <Link to="/study-abroad" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Study Abroad
                </Typography>
              </Link>
              {/* <Link to="/immigration" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Immigration
                </Typography>
              </Link> */}

              <Link to="/test" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Test Prep
                </Typography>
              </Link>

              <Link to="/international-relation" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  International Engagement
                </Typography>
              </Link>
              <Link to="/immersion" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Immersion
                </Typography>
              </Link>
            </Stack>
          </Grid>
          {/* ----- Menu Section ----- */}
          <Grid
            item
            xs={12}
            sm={6}
            md={2.5}
            lg={3}
            xl={3}
            sx={{
              mb: { xs: 2, sm: 0 },
              gap: ".3rem",
              fontWeight: 600,
              fontSize: { xs: 14, md: 20, lg: 21 },
            }}
          >
            <Stack
              sx={{ paddingLeft: { xl: "100px", lg: "80px", md: "70px" } }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 14, md: 20, lg: 21 },
                  paddingBottom: "15px",
                }}
              >
                MENU
              </Typography>
              <Link to="/" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Home
                </Typography>
              </Link>
              <Link to="/aboutus" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Our Story
                </Typography>
              </Link>
              <Link
                to="/study-abroad-consultants-delhi-ncr"
                className="custom-link"
              >
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Delhi NCR
                </Typography>
              </Link>
              <Link
                to="/consultants-study-abroad-kolkata"
                className="custom-link"
              >
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Kolkata
                </Typography>
              </Link>
              <Box
                className="custom-link"
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography
                  // color="#606060"
                  variant="body2"
                  color="#606060"
                  onClick={handleDownload}
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                    "&:hover": {
                      backgroundColor: "#00999E",
                    },
                  }}
                >
                  Download Brochure
                </Typography>
              </Box>

              <Link to="/contact" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Contact Us
                </Typography>
              </Link>
            </Stack>
          </Grid>
          {/* ---------------Other Section-----------*/}
          <Grid
            item
            xs={12}
            sm={6}
            md={2.5}
            lg={3}
            xl={3}
            sx={{
              display: "grid",
              color: "#606060",
              gap: ".3rem",
            }}
          >
            <Stack sx={{ paddingLeft: { lg: "70px", md: "50px" } }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: 14, md: 20, lg: 21 },
                  paddingBottom: "15px",
                }}
              >
                Others
              </Typography>
              <Link to="/privacy-policy" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Privacy Policy
                </Typography>
              </Link>
              <Link to="/refund-policy" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Refund Policy
                </Typography>
              </Link>
              <Link to="/terms-&-conditions" className="custom-link">
                <Typography
                  variant="body2"
                  color="#606060"
                  sx={{
                    fontWeight: 400,
                    fontSize: { xs: 14, md: 16, lg: 17 },
                    padding: {
                      xs: "5px 0",
                      sm: "5px 0",
                      md: "5px 0",
                      lg: "5px 0",
                    },
                  }}
                >
                  Terms and Conditions
                </Typography>
              </Link>
            </Stack>
          </Grid>
        </Grid>

        <Box
          component="footer"
          sx={{
            borderTop: "2px solid #e0e0e0",

            py: 3,
            textAlign: "center",
            color: "#606060",
            fontSize: "14px",
          }}
        >
          <Typography variant="body2">
            Copyright ©️ 2025 Taksheela Institute of Education. All rights
            reserved.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default Footer;
